import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {JobDTO} from "../model/job-dto.model";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class JobsService {

  private _baseUrl = environment.host + "/jobs/announcements";

  constructor(private httpClient: HttpClient) {
  }

  public getAnnouncements(): Observable<JobDTO[]> {
    return this.httpClient.get<JobDTO[]>(this._baseUrl).pipe(
      map((res: JobDTO[]) => res.map(item => new JobDTO(item)))
    );
  }

  public getDetail(id: string): Observable<JobDTO> {
    return this.httpClient.get<JobDTO>(this._baseUrl + "/" + id)
      .pipe(
        map(job => new JobDTO(job))
      );
  }

}
